import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {AfterViewInit, ChangeDetectorRef, Component, forwardRef, Inject, OnInit, OnDestroy, inject} from '@angular/core';
import {FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {concatMap, delay, filter, map, tap} from 'rxjs/operators';
import {STATUS} from 'src/app/shared/services/status/status.model';
import {StatusService} from 'src/app/shared/services/status/status.service';
import {ValidationbirthdayService} from 'src/app/shared/services/validationbirthday/validationbirthday.service';
import {PARAMS, SESSION_STORAGE} from './identification.model';
import {IdentificationService} from './identification.service';
import {ForwardService} from '../../services/forward/forward.service';
import {MatDialog} from '@angular/material/dialog';
import {DOCUMENT} from '@angular/common';
import { TRANSLATE_PATH as TRANSLATE_PATH_PROJECT } from '../../project.model';
import {TRANSLATE_PATH as TRANSLATE_PATH_SHARED } from 'src/app/shared/shared.model'
import {ERROR} from 'build/project/openapi-cast/shared/shared-openapi-cast.model';
import {SharedOpenapiCastService} from 'build/project/openapi-cast/shared/shared-openapi-cast.service';
import {IIdentifier} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {SuccessDialogComponent} from '../../dialogs/success-dialog/success-dialog.component';
import {FIELDWIDTH} from '../../components/field-item-row/row.model';
import {TranslateDesignPipe} from 'src/app/shared/pipes/translate-design/translate-design.pipe';


export const MY_FORMATS: any = {
   parse: {
      dateInput: ['DD.MM.YYYY']
   },
   display: {
      dateInput: 'DD.MM.YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY'
   }
};

@Component({
   selector: 'app-identification',
   templateUrl: './identification.component.html',
   styleUrls: ['./identification.component.scss'],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => IdentificationComponent)
      },
      {
         provide: NG_VALIDATORS,
         multi: true,
         useExisting: IdentificationComponent
      },
      {provide: MAT_DATE_LOCALE, useValue: 'de'},
      {
         provide: DateAdapter,
         useClass: MomentDateAdapter,
         deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
   ],
   standalone: false
})

export class IdentificationComponent implements OnDestroy, OnInit, AfterViewInit {

   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);
   private dialog =inject(MatDialog);
   public sSharedOpenapi = inject(SharedOpenapiCastService);
   public sIdentification = inject(IdentificationService);
   public sValidationBirthday = inject(ValidationbirthdayService);
   private activatedRoute = inject(ActivatedRoute);
   private fb = inject(FormBuilder); 
   private cdRef = inject(ChangeDetectorRef);
   public sStatus = inject(StatusService); 
   private sForward = inject(ForwardService);

   public TRANSLATE_PATH_PROJECT = TRANSLATE_PATH_PROJECT; 
   public TRANSLATE_PATH_SHARED = TRANSLATE_PATH_SHARED; 

   public identificationFormGroup: FormGroup = this.fb.group({});
   public FIELDWIDTH: typeof FIELDWIDTH = FIELDWIDTH;
   private loaded_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public loaded$: Observable<boolean> = this.loaded_.asObservable();

   constructor (@Inject(DOCUMENT) public readonly document: Document) {
   }
   
   get window (): Window {
      return this.document.defaultView!;
   }
   
   ngOnInit (): void {
      this.sSharedOpenapi.isConnected$.pipe(
         filter(res => res == ERROR.CONNECT),
         concatMap(_ => this.init())
      ).subscribe(res => {
         this.identificationFormGroup.updateValueAndValidity({emitEvent: false, onlySelf: true});
         if (sessionStorage.getItem(SESSION_STORAGE.CONSULTANTUUID)) this.sValidationBirthday.isModule = true;
         this.loaded_.next(res);
      });

      this.sStatus.status$.pipe(
         tap(_ => this.cdRef.detectChanges()),
         filter(value => value == STATUS.LOGINREDIRECT),
         delay(this.sStatus.delayTimeRedirect)
      ).subscribe(() => {
         this.window.open(this.sStatus.agreementUrl, this.sStatus.target);
      });
   }

   ngAfterViewInit (): void {
      this.cdRef.detectChanges();
   }

   ngOnDestroy (): void {
      this.reset();
   }

   private reset (): void {
      this.loaded_.next(false);
      this.identificationFormGroup = this.fb.group({});
      this.sIdentification.birthdayPattern = "";
      this.sIdentification.startWithoutBirthday = false;
   }

   private init (): Observable<boolean> {

      const pattern = this.pTranslateDesign.transform(TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_PATTERN);
      this.sIdentification.birthdayPattern = pattern && pattern != TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_PATTERN ? pattern : ""; 
   
      this.sIdentification.startWithoutBirthday = this.pTranslateDesign.transform(TRANSLATE_PATH_PROJECT.IDENTIFICATION_STARTWITHOUTBIRTHDAY) == "true" ? true : false; 

      this.sIdentification.setToggle();

      return this.activatedRoute.queryParams.pipe(
         map(params =>  {
            if (params[PARAMS.CONSULTANT]) sessionStorage.setItem(SESSION_STORAGE.CONSULTANTUUID, params[PARAMS.CONSULTANT]);
            return this.initializeFormGroup(params[PARAMS.ID] || '')
         }),
         tap(() => this.sStatus.status = STATUS.NONE)
      );
   }

   private setFormControlBirthday (withBirthday: boolean) {
      const parentControl: FormGroup = this.identificationFormGroup;
      if (withBirthday) {
         if (!('formControlBirthday' in parentControl.controls)) {
            parentControl.addControl('formControlBirthday', this.fb.control('', {validators: [], updateOn: 'change'}));
         }
      } else parentControl.removeControl(('formControlBirthday'));
   }

   get privacy (): string {
      return this.identificationFormGroup.controls.toggle.value;
   }

   get withBirthday (): boolean {
      return this.sValidationBirthday.birthday && 'formControlBirthday' in this.identificationFormGroup.controls;
   }

   private initializeFormGroup (uuid: string): boolean {
      this.identificationFormGroup = this.fb.group({
         formControlUuid: this.fb.control(uuid, {validators: [ Validators.pattern("^[ a-zA-ZöäüÖÄÜ0-9-]{0,1000}$") ], updateOn: 'change'}),
         toggle: this.fb.control({}, {validators: [Validators.required], updateOn: 'change'})
      });
      
      this.setFormControlBirthday(this.sIdentification.checkIsWithBirthday(uuid));

      this.identificationFormGroup.controls.toggle.statusChanges.subscribe(_ => {
         if (this.identificationFormGroup.controls.toggle.invalid && this.identificationFormGroup.controls.toggle.hasError('required')) return;
         this.identificationFormGroup.controls.formControlUuid.markAsTouched({onlySelf: false});
         this.identificationFormGroup.controls.formControlUuid.updateValueAndValidity({onlySelf: false});
      });

      this.identificationFormGroup.controls.formControlUuid.valueChanges.subscribe(value => {
         this.setFormControlBirthday(this.sIdentification.checkIsWithBirthday(value));
         this.cdRef.detectChanges();
      });

      return true;
   }

   public onNextClick () {
      const identifier: IIdentifier = {
         code: this.identificationFormGroup.controls.formControlUuid.value,
         birthday: this.identificationFormGroup.controls.formControlBirthday && this.identificationFormGroup.controls.formControlBirthday.value ? this.identificationFormGroup.controls.formControlBirthday.value.format("DD.MM.yyyy") : ''
      };

      this.sIdentification.setIdentifier(identifier);
      this.sForward.loadConsent().subscribe(_ => (this.sForward.afterLogin && this.sForward.afterLogin == true) ? this.openDialog() : this.sIdentification.navigateNextPage());
   }

   private openDialog () {
      this.sStatus.status = this.sForward.consent && this.sForward.afterLogin ? STATUS.LOGINREDIRECT : STATUS.SUCCESS;
      sessionStorage.clear();
      this.dialog.open(SuccessDialogComponent, {
         ariaModal: true,
         role: "dialog",
         autoFocus: "first-tabbable",
         disableClose: true,
         hasBackdrop: true,
         backdropClass: 'backdrop-background-GD'
      });
   }
}